import styled from 'styled-components';
import { Mixins } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Wrapper = styled.div<{ hideOnMobile: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ hideOnMobile }) =>
    hideOnMobile
      ? Mixins.Media.maxWidthSmall(`
        display: none;
      `)
      : ``}
`;

export const BackButtonContainer = styled.div<{ showOnMobile: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  display: none;

  ${({ showOnMobile }) =>
    showOnMobile
      ? Mixins.Media.maxWidthSmall(`
        display: block;
      `)
      : ``}
`;
